import LoginPage from '../features/auth/LoginPage';
import TwoFactorPage from '../features/auth/TwoFactorPage';
import DeveloperPage from '../features/developer/DeveloperPage';
import HistoryPage from '../features/history/HistoryPage';
import { PlanCreditPage } from '../features/navigation/UtilityPages';
import ProjectPage from '../features/projects/ProjectPage';
import ResultPage from '../features/results/ResultPage';
import SecurityPage from '../features/security/SecurityPage';
import AccountSettingsPage from '../features/settings/AccountSettingsPage';
import DataPrivacyPage from '../features/settings/DataPrivacyPage';
import OptionSettingsPage from '../features/settings/OptionSettingsPage';
import { LanguageSettingsPage, LegalSupportSettingsPage, NotificationSettingsPage, SettingsIndexPage } from '../features/settings/SettingsHubPage';
import TemplateSettingsPage from '../features/settings/TemplateSettingsPage';
import ShareManagementPage from '../features/share/ShareManagementPage';
import type { RouteMatch } from './route-registry';
import { AccountPlatformPage } from './pages/AccountPages';
import { AuthPage } from './pages/AuthPages';
import { PublicPlatformPage } from './pages/PublicPages';
import { WorkspacePage } from './pages/WorkspacePages';

const authRoutes = new Set(['register', 'verify-email', 'forgot-password', 'reset-password', 'password-setup']);
const workspaceRoutes = new Set(['settings-storage-destinations', 'settings-astera-storage']);
const accountRoutes = new Set(['account-subscription', 'account-credit', 'billing-status']);

export function CanonicalPage({ route }: { route: RouteMatch }) {
  if (route.id === 'login') return <LoginPage route={route} />;
  if (route.id === 'two-factor') return <TwoFactorPage route={route} />;
  if (authRoutes.has(route.id)) return <AuthPage route={route} />;
  if (route.id === 'plan-credit') return <PlanCreditPage route={route} />;
  if (route.id === 'projects') return <ProjectPage route={route} />;
  if (route.id === 'history') return <HistoryPage route={route} />;
  if (route.id === 'result-detail') return <ResultPage route={route} />;
  if (route.id === 'shares') return <ShareManagementPage route={route} />;
  if (route.id === 'settings') return <SettingsIndexPage route={route} />;
  if (route.id === 'settings-language') return <LanguageSettingsPage route={route} />;
  if (route.id === 'settings-notifications') return <NotificationSettingsPage route={route} />;
  if (route.id === 'settings-legal-support') return <LegalSupportSettingsPage route={route} />;
  if (route.id === 'settings-options') return <OptionSettingsPage route={route} />;
  if (route.id === 'settings-templates') return <TemplateSettingsPage route={route} />;
  if (route.id === 'settings-data-privacy') return <DataPrivacyPage route={route} />;
  if (route.id === 'developer') return <DeveloperPage route={route} />;
  if (workspaceRoutes.has(route.id)) return <WorkspacePage route={route} />;
  if (route.id === 'account') return <AccountSettingsPage route={route} />;
  if (route.id === 'account-security') return <SecurityPage route={route} />;
  if (accountRoutes.has(route.id)) return <AccountPlatformPage route={route} />;
  return <PublicPlatformPage route={route} />;
}
